import { IPortfolioPerformanceAccounts } from '../portfolio-performance.types';

// Suffix names by what the strategy actually does (e.g. "Buy and Hold" for
// today's simple spot-hold baseline) rather than a generic "(Reference)"
// tag, so future non-buy-and-hold reference strategies (e.g. a covered
// call baseline) can be labelled accordingly instead of all looking the
// same in the account list.
export const makeReferenceAccount = (
  displaySymbol: string,
  strategyLabel: string,
): IPortfolioPerformanceAccounts => ({
  name: `${displaySymbol} (${strategyLabel})`,
  // Bare display symbol, not the RPC underlying (e.g. 'SOL', not
  // 'SOL_USDC') — this is what CryptoIcon/token-icon-sources look up
  // against, and CDN/local icon sets are keyed on the bare ticker.
  symbols: [displaySymbol],
  // Own group in the account-selection sidebar (MultiSelectAccountsByExchange
  // groups by this field) — sits alongside Deribit/OKX, sorted after both
  // alphabetically ('deribit' < 'okx' < 'reference').
  exchange: 'reference',
  venue: 'reference',
  last_tick: '',
});

// Pattern-based rather than a static-list membership check — the reference
// token universe is now dynamic (~80+ tokens from list_prices via
// use-reference-strategy-tokens.ts, not a fixed 6), so this can't check
// against a fixed array. Every reference account name is built by
// makeReferenceAccount above, always ending "(<strategy label>)"; "Buy and
// Hold" is the only strategy label in use today.
export const isReferenceStrategyAccount = (accountName: string): boolean =>
  accountName.endsWith(' (Buy and Hold)');
